import React, { Component } from "react";
import { Badge, Tabs, Popover } from "antd";
import { connect } from "react-redux";
import { langCheck, isInsideTab } from "Pub/js/utils";
import { setStore, getStore } from "Pub/js/storageUtils";
import Ajax from "Pub/js/ajax";
import { toast } from 'nc-lightapp-front';
import { setMessageData } from "Store/appStore/action";
import { OpenLink } from "./openLink";
import moment from "moment";
import platform from "Pub/js/platform";
import _ from "lodash";
const { base, pageTo, formatDatetime, serverTimeToLocal, PubSub } = platform;
const TabPane = Tabs.TabPane;
const { NCDiv, NCTooltip } = base;
import smile from 'Assets/images/smile.png';
import idea from 'Assets/images/empty.svg';
import Loading from "../../../components/Loading";
class Message extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabActiveKey: "approve",
            visible: false,
            messageCount: {
                approvecount: 0,
                todocount: 0,
                prealertcount: 0,
                noticecount: 0,
                totalcount: 0,
            },
            tipShow: false,
            messageLoading: false
        };
    }
    componentDidMount() {
        window.addEventListener("storage", this.receiveMessage, false);
        let messageCount = getStore("messageCount");
        messageCount && this.setState({ messageCount: messageCount });
        //审批中心部件点刷新需要同步消息中心数据，这里监听一下
        this.pubsub = PubSub.subscribe("refreshMessageCount", (action, data) => {
            if (data !== undefined) {
                let { messageCount } = this.state;
                messageCount.totalcount = data.totalCount;
                const cacheMessageCount = getStore("messageCount") || {};
                // 合并缓存中的
                const newMessageCount = { ...cacheMessageCount, ...messageCount };
                setStore("messageCount", newMessageCount);
                this.setState({ messageCount: newMessageCount });
            }
        });
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.newMsg !== nextProps.newMsg) {
            this.forceUpdate();
        }
    }
    componentWillUnmount() {
        window.removeEventListener("click", this.messageClick);
        window.removeEventListener("storage", this.receiveMessage, false);
        PubSub.unsubscribe(this.pubsub); //移除订阅
    }

    receiveMessage = event => {
        if (
            (event.key === "newMessage" && event.newValue == "workBenchMessage") ||
            (event.key === "workBenchMsg" && event.newValue == "workBenchMessage")
        ) {
            setTimeout(() => {
                let messageCount = getStore("messageCount");
                if (messageCount) {
                    this.setState(
                        { messageCount: messageCount },
                        () => {
                            setStore("workBenchMsg", "");
                            setStore("newMessage", "");
                        },
                    );
                }
            }, 500);
        }
        if (event.key === "messageCount") {
            this.setState({ messageCount: getStore("messageCount") });
        }
    };
    // 解决iframe下点击 弹窗不关闭
    messageClick = () => {
        let { visible } = this.state;
        let that = this;
        let ifrs = document.querySelectorAll("#mainiframe");
        ifrs.forEach((ifr, index) => {
            if (ifr) {
                ifr.contentDocument.onclick = function () {
                    if (visible) {
                        that.handleVisibleChange(false);
                    }
                };
                let detailIframe = ifr.contentDocument.getElementById("detailIframe");
                if (detailIframe) {
                    detailIframe.contentDocument.onclick = function () {
                        if (visible) {
                            that.handleVisibleChange(false);
                        }
                    };
                }
            }
        });
    };
    // 控制popover显隐性
    handleVisibleChange = async flag => {
        let messageCount = getStore("messageCount");
        if (!messageCount) {
            return;
        }
        let { messageData } = this.props;
        let { tabActiveKey } = this.state;
        if (flag) {
            window.addEventListener("click", this.messageClick);
            if (tabActiveKey !== "approve") {
                messageData[`${tabActiveKey}item`] = [];
                await this.props.setMessageData(messageData);
                this.getTabMessage(0, tabActiveKey);
            } else {
                if (!(messageData[`approveitem`] && messageData[`approveitem`].length)) {
                    // 没有审批数据时请求
                    // 如果审批没有数据 优先展示有数据的页签
                    if (messageCount.approvecount && +messageCount.approvecount == 0) {
                        if (messageCount.todocount && +messageCount.todocount !== 0) {
                            this.tabChange("todo");
                        } else if (
                            messageCount.prealertcount &&
                            +messageCount.prealertcount !== 0
                        ) {
                            this.tabChange("prealert");
                        } else if (
                            messageCount.noticecount &&
                            +messageCount.noticecount !== 0
                        ) {
                            this.tabChange("notice");
                        } else {
                            this.tabChange("approve");
                        }
                    } else {
                        await this.getTabMessage(0, "approve");
                    }
                } else {
                    if (messageData[`approveitem`].length) {
                        messageData[`approveitem`] = [];
                        await this.props.setMessageData(messageData);
                        this.getTabMessage(0, "approve");
                    }
                }
            }
            this.setState({ visible: flag });
        } else {
            window.removeEventListener("click", this.messageClick);
            this.setState({ visible: flag });
        }
    };
    // 查看全部
    checkAll = () => {
        let { tabActiveKey } = this.state;
        switch (tabActiveKey) {
            // 跳审批
            case "approve":
                pageTo.openTo("/nccloud/resources/uap/msgcenter/message/main/index.html", { appcode: "10160501" });
                break;
            // 跳业务
            case "todo":
                pageTo.openTo("/nccloud/resources/uap/msgcenter/message/main/index.html?msgType=todo", { appcode: "10160502" });
                break;
            // 跳预警
            case "prealert":
                pageTo.openTo(
                    "/nccloud/resources/uap/msgcenter/message/main/index.html?msgType=prealert",
                    { appcode: "10160503" },
                );
                break;
            // 跳通知
            case "notice":
                pageTo.openTo(
                    "/nccloud/resources/uap/msgcenter/message/main/index.html?msgType=notice",
                    { appcode: "10160504" },
                );
                break;
            default:
                break;
        }
        this.handleVisibleChange(false);
    };
    /**
     * 标记已读(审批/业务无此功能 直接跳转)
     */
    markRead = item => {
        let { messageData } = this.props;
        let messageCount = getStore("messageCount");
        let { tabActiveKey } = this.state;
        let minusLen = 0;
        const MessageTypes = ['approve', 'todo', 'notice'];
        // 审批 业务
        if (MessageTypes.indexOf(tabActiveKey) > -1 && item) {
            OpenLink.call(this, item);
            if (isInsideTab()) {
                this.handleVisibleChange(false);
            }
            return;
        }
        if (messageData[`${tabActiveKey}item`] && messageData[`${tabActiveKey}item`].length) {
            minusLen = messageCount[`${tabActiveKey}count`] || 0;
        } else {
            return;
        }
        Ajax({
            url: "/nccloud/riart/message/setRead.do",
            data: {
                requestType: "readall",
                message_type: tabActiveKey,
                isread: "Y",
            },
            info: {
                name: langCheck("0000PUB-000113") /* 国际化处理： 消息*/,
                action: langCheck("0000PUB-000271") /* 国际化处理： 标记已读*/,
            },
            success: ({ data }) => {
                if (data.success) {
                    messageData[`${tabActiveKey}item`] = [];
                    // 设置redux数据
                    this.props.setMessageData(messageData);
                    let messageCount = getStore("messageCount");
                    if (messageCount.totalcount) {
                        messageCount[`${tabActiveKey}count`] = 0;
                        messageCount.totalcount = messageCount.totalcount - minusLen;
                    }
                    setStore("messageCount", messageCount);
                    messageCount = {
                        approvecount: messageCount.approvecount,
                        todocount: messageCount.todocount,
                        prealertcount: messageCount.prealertcount,
                        noticecount: messageCount.noticecount,
                        totalcount: messageCount.totalcount,
                        ybcount: messageCount.ybcount,
                        serviceurl: messageCount.serviceurl,
                        ...messageCount,
                    };
                    this.setState({ messageCount: messageCount });
                    setStore("newMessage", "workBenchMessage");
                    setStore("messageCount", messageCount);
                    this.forceUpdate();
                }
            },
            error: error => {
                console.log(error);
            },
        });
    };
    // 获取badge组件
    getBadge = finished => {
        let messageCount = getStore("messageCount");
        const { visible, tipShow } = this.state;
        const overlay = finished
            ? langCheck("0000PUB-000272") /* 国际化处理： 工作处理完了，干得漂亮！*/
            : langCheck("0000PUB-000483") /* 国际化处理： 消息中心*/;
        return (
            <div>
                <div className='iconContainer'>
                    <Badge count={messageCount && messageCount.totalcount}>
                        <NCTooltip
                            visible={tipShow && !visible}
                            placement='bottom'
                            overlay={overlay}
                        >
                            <i
                                className='iconfont icon-xiaolingdang'
                                onMouseEnter={() => {
                                    this.tipTimer = setTimeout(() => {
                                        this.setState({
                                            tipShow: true
                                        })
                                    }, 500);
                                }}
                                onMouseLeave={() => {
                                    clearTimeout(this.tipTimer);
                                    this.setState({
                                        tipShow: false
                                    })
                                }}
                            />
                        </NCTooltip>
                    </Badge>
                </div>
            </div>
        );
    };
    /**
     * 获取消息主题内容
     * ≤1小时：展示生成时间和当前时间差，精度到分钟
     * ≤24小时：展示生成时间和当前时间差，精度到小时
     * ≥24小时：展示某条未读消息生成的具体日期。精度到年月日，日期格式同语言环境
     * currentTime:服务器当前时间 2111版本增加
     */
    reverseTime = (sendtime, currentTime) => {
        // let { businessDate } = this.props;
        // let nowDate = businessDate ? businessDate.substring(0, 10) : moment().format("YYYY-MM-DD");
        // let nowTime = currentTime && localTimeToServer(moment(currentTime)).format("HH:mm:ss"); //转成服务器时区时间进行计算
        // const now = `${nowDate} ${nowTime}`;
        let result;
        const now = currentTime;
        let diffTime = moment(now).diff(sendtime, "minutes");
        let newSendtime = serverTimeToLocal(moment(sendtime), "1").format("YYYY-MM-DD HH:mm:ss"); //服务器时区强制转成客户端时区
        if (typeof diffTime == "number") {
            if (diffTime == 0) {
                result = `1${langCheck("0000PUB-000264")}`; /* 国际化处理： 分钟前*/
            } else if (diffTime <= 60 && diffTime > 0) {
                result = `${diffTime}${langCheck("0000PUB-000264")}`; /* 国际化处理： 分钟前*/
            } else if (diffTime > 60 && diffTime <= 1440) {
                let hour = moment(now).diff(sendtime, "hour");
                result = `${hour}${langCheck("0000PUB-000265")}`; /* 国际化处理： 小时前*/
            } else if (diffTime < 0) {
                result = newSendtime;
            } else {
                result = newSendtime;
            }
            return result;
        } else {
            return newSendtime;
        }
    };
    /**
     * 获取消息主题内容
     */
    getContainer = (key, finished) => {
        let { messageData } = this.props;
        let messageCount = getStore("messageCount");
        const msgKey = key.substring(0, key.indexOf('item'));
        const number = messageCount && messageCount[`${msgKey}count`] || '0';
        return (
            <NCDiv fieldid='message' areaCode={NCDiv.config.List} style={{ height: "100%" }}>
                {" "}
                {/* 自动化测试标记 勿删 */}
                {
                    finished ? this.renderAllIsEmpty() :
                        number === '0' ? this.renderOneIsEmpty() :
                            messageData &&
                            messageData[key] &&
                            messageData[key].map((item, index) => {
                                const MessageTypes = ['approveitem', 'todoitem', 'noticeitem'];
                                let typeIdx = MessageTypes.indexOf(key);
                                let cursorStyle = { cursor: 'unset' };
                                let hasFuncCode = item.funccode && item.funccode.length > 0;
                                let noticeNeedPointer = typeIdx === 2 && hasFuncCode && (!item.billtype || item.detail);
                                if (noticeNeedPointer || (typeIdx > -1 && typeIdx < 2)) {
                                    cursorStyle = { cursor: 'pointer' };
                                }
                                return (
                                    <NCDiv
                                        className='tabContainter'
                                        areaCode={NCDiv.config.ListItem}>
                                        {" "}
                                        {/* 自动化测试标记 勿删 */}
                                        <div className='messageTitle'>
                                            <p
                                                title={item.subject}
                                                onClick={() => {
                                                    if (MessageTypes.indexOf(key) > -1) {
                                                        this.markRead(item);
                                                    }
                                                }}
                                                style={cursorStyle}>
                                                {item.subject}
                                            </p>
                                        </div>
                                        <div className='messageContent'>
                                            <div className='sender' title={item.senderName}>
                                                <span>
                                                    {langCheck("0000PUB-000278")}
                                                    <span fieldid='sender'>
                                                        {item.senderName}
                                                    </span>
                                                </span>
                                            </div>
                                            <div
                                                className='timeRight'
                                                title={item.sendtime}>
                                                <span>
                                                    {formatDatetime(this.reverseTime(item.sendtime, messageData.currentTime), 'datetime')}
                                                </span>
                                            </div>
                                        </div>
                                    </NCDiv>
                                );
                            })
                }
            </NCDiv>
        );
    };
    // 全部为空
    renderAllIsEmpty = () => {
        return (
            <p className='empty-p'><img src={smile} alt="" />{langCheck("0000PUB-000272") /** 工作处理完了，干得漂亮！ */}</p>
        );
    }
    // 个别为空
    renderOneIsEmpty = () => {
        return (
            <p className='empty-p'><img src={idea} alt="" />{langCheck("0000PUB-000365") /** 暂无数据 */}</p>
        );
    }
    getUrlYbmessage = serviceurl => {

        Ajax({
            url: "/nccloud/riart/message/linkToYBMessageCenter.do",
            data: { serviceurl: serviceurl },
            success: ({ data }) => {
                if (data.success) {
                    window.open(data.data.yburl);
                    this.handleVisibleChange(false);
                }
            },
            error: error => {
                console.log(error);
            },
        });

    }

    getTabMessage = (...args) => {
        return new Promise((resolve) => {
            this.setState({
                messageLoading: true
            })
            this.props.getMessage(...args, () => {
                this.setState({
                    messageLoading: false
                })
                resolve();
            });
        })
    }

    // tab切换
    tabChange = async tabActiveKey => {
        if (tabActiveKey == 'yb') {
            let messageCount = getStore("messageCount");
            if (messageCount.ybflag == "2") {
                toast({ title: messageCount.ybmessage, color: 'warning' });
                return;
            } else {
                let serviceurl = messageCount.serviceurl;
                if (serviceurl) {
                    //window.open(serviceurl)
                    this.getUrlYbmessage(serviceurl);
                }
                return;
            }

        }
        let { messageData } = this.props;
        if (!(messageData[`${tabActiveKey}item`] && messageData[`${tabActiveKey}item`].length)) {
            // 切换页签没有数据再请求
            if (tabActiveKey != 'yb') {
                await this.getTabMessage(0, tabActiveKey);
            }

        }
        //  this.updateYbmessage();
        this.setState({ tabActiveKey: tabActiveKey });
    };
    // 滚动加载
    onScroll = e => {
        let { tabActiveKey } = this.state;
        let { messageData } = this.props;
        let curCount = messageData[`${tabActiveKey}item`].length;
        let index = Math.ceil(+curCount / 10);
        let curIndex = index - 1 >= 0 ? index - 1 : 0;
        if (e.target && e.target.scrollTop) {
            let scrollTop = e.target.scrollTop;
            // 超过100条数据不再滚动加载
            if (scrollTop >= (e.target.firstChild.children[0].clientHeight + 1) * (10 * curIndex + 4) && index < 10) {
                this.getTabMessage(index + 1, tabActiveKey);
            }
        }
    };
    /**
     * 统一处理现实消息数，超过100，现实99+
     */
    renderMessageCount = count => {
        return (
            <React.Fragment>
                {(<span>{count > 99 ? '99+' : count}</span>)}
            </React.Fragment>
        );
    }

    render() {
        let messageCount = getStore("messageCount");
        let { tabActiveKey, messageLoading } = this.state;
        let { messageData } = this.props;
        let finished = messageCount && +messageCount.totalcount == 0 ? true : false;
        //审批
        let approveTab =
            messageCount && messageCount.approvecount ? (
                <div>
                    {langCheck("0000PUB-000266")} {this.renderMessageCount(messageCount.approvecount)}
                </div>
            ) : (
                <div>{langCheck("0000PUB-000266")}</div>
            );
        //业务
        let todoTab =
            messageCount && messageCount.todocount ? (
                <div>
                    {langCheck("0000PUB-000267")} {this.renderMessageCount(messageCount.todocount)}
                </div>
            ) : (
                <div>{langCheck("0000PUB-000267")}</div>
            );
        //预警
        let prealertTab =
            messageCount && messageCount.prealertcount ? (
                <div>
                    {langCheck("0000PUB-000268")} {this.renderMessageCount(messageCount.prealertcount)}
                </div>
            ) : (
                <div>{langCheck("0000PUB-000268")}</div>
            );
        //通知
        let noticeTab =
            messageCount && messageCount.noticecount ? (
                <div>
                    {langCheck("0000PUB-000269")} {this.renderMessageCount(messageCount.noticecount)}
                </div>
            ) : (
                <div>{langCheck("0000PUB-000269")}</div>
            );
        let ybMessagTab =
            messageCount && messageCount.ybcount ? (
                <div>
                    {langCheck("0000PUB-000476")} {this.renderMessageCount(messageCount.ybcount)}
                </div>
            ) : (
                <div>{langCheck("0000PUB-000476")}</div>
            );
        const container = (
            <NCDiv fieldid='message' areaCode={NCDiv.config.MODAL} /* 自动化测试标记 勿删 */>
                <div className='message-content' onScroll={e => this.onScroll(e)}>
                    <Tabs
                        activeKey={tabActiveKey}
                        onChange={this.tabChange}
                        renderTabBar={(props, DefaultTabBar) => (
                            <NCDiv areaCode={NCDiv.config.TABS}>
                                {" "}
                                {/* 自动化测试标记 勿删 */}
                                <DefaultTabBar {...props} />
                            </NCDiv>
                        )}>
                        <TabPane tab={approveTab} /* 国际化处理： 审批*/ key='approve'>
                            {this.getContainer("approveitem", finished)}
                        </TabPane>
                        <TabPane tab={todoTab} /* 国际化处理： 业务*/ key='todo'>
                            {this.getContainer("todoitem", finished)}
                        </TabPane>
                        <TabPane tab={prealertTab} /* 国际化处理： 预警*/ key='prealert'>
                            {this.getContainer("prealertitem", finished)}
                        </TabPane>
                        <TabPane tab={noticeTab} /* 国际化处理： 通知*/ key='notice'>
                            {this.getContainer("noticeitem", finished)}
                        </TabPane>
                        {messageCount && messageCount.ybflag && messageCount.ybflag != "0" && (

                            <TabPane tab={ybMessagTab} /* 国际化处理： 通知*/ key='yb' >

                            </TabPane>)

                        }

                    </Tabs>

                    {tabActiveKey === "approve" || tabActiveKey === "todo" ? (
                        <NCDiv areaCode={NCDiv.config.BOTTOM}>
                            {" "}
                            {/* 自动化测试标记 勿删 */}
                            <footer className='approveitemFooter'>
                                <div onClick={this.checkAll}
                                    className='nc-theme-link-font-c'>
                                    {langCheck(
                                        "0000PUB-000270",
                                    ) /* 国际化处理： 查看全部*/}
                                </div>
                            </footer>
                        </NCDiv>
                    ) : (
                        <NCDiv areaCode={NCDiv.config.BOTTOM}>
                            {" "}
                            {/* 自动化测试标记 勿删 */}
                            <footer className='otheritemFooter'>
                                <div onClick={this.checkAll} className='nc-theme-link-font-c'>
                                    {langCheck(
                                        "0000PUB-000270",
                                    ) /* 国际化处理： 查看全部*/}
                                </div>
                                <div
                                    onClick={e => {
                                        this.markRead();
                                    }}
                                    className={
                                        messageData[`${tabActiveKey}item`] &&
                                            messageData[`${tabActiveKey}item`]
                                                .length
                                            ? "nc-theme-link-font-c"
                                            : "notAllowed nc-theme-link-font-c"
                                    }>
                                    {langCheck(
                                        "0000PUB-000271",
                                    ) /* 国际化处理： 标记已读*/}
                                </div>
                            </footer>
                        </NCDiv>
                    )}

                </div>
                {
                    messageLoading && <Loading style={{
                        position: 'absolute',
                        width: '100%',
                        top: 0
                    }} />
                }
            </NCDiv>
        );
        return <div>
            <Popover
                trigger='click'
                className='message item-wrap'
                overlayClassName="message-popup"
                content={container}
                title=''
                visible={this.state.visible}
                defaultVisible={true}
                onVisibleChange={this.handleVisibleChange}
                getPopupContainer={() =>
                    document.getElementsByClassName("message") &&
                    document.getElementsByClassName("message")[0]
                }>
                {this.getBadge(finished)}
            </Popover>
        </div>;

    }
}
export default connect(
    state => ({
        businessDate: state.appData.businessDate,
        messageData: state.appData.messageData,
        newMsg: state.appData.newMsg,
    }),
    { setMessageData },
)(Message);
